import { render, staticRenderFns } from "./AcoesFracassar.vue?vue&type=template&id=1ba24cf7&scoped=true"
import script from "./AcoesFracassar.vue?vue&type=script&lang=js"
export * from "./AcoesFracassar.vue?vue&type=script&lang=js"
import style0 from "./AcoesFracassar.vue?vue&type=style&index=0&id=1ba24cf7&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba24cf7",
  null
  
)

export default component.exports